import TextField from '@mui/material/TextField';
import { alpha, styled } from '@mui/material/styles';

/** Outlined text field whose input area takes a faint brand tint while highlighted. */
export const HighlightTextField = styled(TextField, {
  shouldForwardProp: prop => prop !== 'highlighted',
})<{ highlighted: boolean }>(({ theme, highlighted }) => ({
  '& .MuiOutlinedInput-root': {
    backgroundColor: highlighted ? alpha(theme.palette.primary.main, 0.06) : 'transparent',
  },
}));
